import API from '@configs/api';
import apiMethod from '@utility/api_method';

export const checkTestEvent = async (eventId) => {
  try {
    const { data } = await apiMethod.get(`${API.MST_TEST_EVENT_CHECK_TESTING}`, {
      params: { eventId },
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};

export const createTestEvent = async (payload) => {
  try {
    const { data } = await apiMethod.post(`${API.MST_TEST_EVENT_CREATE}`, {
      ...payload,
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};

export const deleteTestEvent = async (list_id) => {
  try {
    const { data } = await apiMethod.delete(`${API.MST_TEST_EVENT_DELETE}`, {
      data: { ...list_id },
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};

export const onDeleteData = async (payload) => {
  try {
    const { data } = await apiMethod.post(`${API.DELETE_DATA}`, payload);
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};

export const checkEventDelete = async (id) => {
  try {
    const { data } = await apiMethod.get(`${API.CHECK_EVENT_DELETE}`, {
      params: { id },
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};

export const getDataByGroupId = async (id) => {
  try {
    const { data } = await apiMethod.get(`${API.GROUP_INVITE_DETAIL}`, {
      params: { id },
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};
